export default function Marquee({ items = [], className = "" }) {
  // duplicate the list to make seamless loop
  const doubled = [...items, ...items];
  return (
    <div className={`marquee overflow-hidden ${className}`}>
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-6 px-6 font-mono-meta text-[11px] tracking-[0.32em] uppercase"
          >
            <span>{item}</span>
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#6B8FAE] accent-pulse" />
          </span>
        ))}
      </div>
    </div>
  );
}
